// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snapshot-creation-device-settings__description {
  color: var(--danger);
}

.snapshot-creation-device-settings__errors-list {
  margin-bottom: var(--base-sizes-10);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/SnapshotCreation/SnapshotCreationDeviceSettings.css","webpack://./services/frontend/app/components/SnapshotCreation/SnapshotCreationDeviceSettings.css"],"names":[],"mappings":"AADA;ECEE,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC","sourcesContent":[".snapshot-creation-device-settings__description {\n  color: var(--danger);\n}\n\n.snapshot-creation-device-settings__errors-list {\n  margin-bottom: var(--base-sizes-10);\n}\n",".snapshot-creation-device-settings__description {\n  color: var(--danger);\n}\n\n.snapshot-creation-device-settings__errors-list {\n  margin-bottom: var(--base-sizes-10);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
